import React from 'react';
import TooltipWithArrow from '../../common/TooltipWithArrow';

interface TooltipHintProps {
  id: string;
  hint: string;
}

const TooltipHint = ({ id, hint }: TooltipHintProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <TooltipWithArrow
        id={id + 'Tip'}
        title={hint}
        placement="right"
        config={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 10],
              },
            },
          ],
        }}>
        <div id={id + 'Info'} className="tooltip-hint" style={{ cursor: 'pointer' }}>
          <i className="material-icons-outlined small">lightbulb</i>
        </div>
      </TooltipWithArrow>
    </>
  );
};

export default TooltipHint;
